import React from 'react'
import { Hero, About, Services, Whyus, Partners, Contactus, Successstories, Skills } from '../../container';

const Home = () => {
  return (
    <>

      {/* <Sidebar /> */}
      <div id="Top" />
      <div id="home" />
    <Hero />
      {/* <a href="#Top"> <button className='toTop'>Scroll To Top </button></a> */}
    <div id="About Us" />
    <hr className="HrBreak"/>
      <About />
    {/* <hr className="HrBreak"/> */}
      {/* <Mvv /> */}
    <div id="Skills" />
      <hr className="HrBreak" />
      
      <Skills />

    <div id="Services" />
    <hr className="HrBreak"/>
    <Services />      
      
    <div id="Partners" />
    <hr className="HrBreak"/>
    <Partners />
      
      
    <div id="Success Stories" />
    <hr className="HrBreak"/>
      <Successstories />
      
    
    <div id="Why Us" />
    <hr className="HrBreak" />
      <Whyus />
      
    <div id="Contact Us" />
    <hr className="HrBreak"/>
    <Contactus />
        
    </>
  )
}

export default Home;